export const salesDealTypes = {
  accumulative_with_registration: 'accumulative_with_registration',
  accumulative: 'accumulative',
  regular: 'regular',
  loyalty_program: 'loyalty_program',
};
